import { Toast } from '@easyvaas/js-components';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { useClosePopup } from '../../hooks/useClosePopup';
import { composeImage, imagesV3Data } from '../../services';
import { materialItemSelector } from '../../store/selector';
import { imagePopupState } from '../../store/state';
import ImageOperationPopup from '../ImageOpreationPopup';
import styles from './index.module.scss';
const ComposePopup = () => {
  const { target } = useRecoilValue(imagePopupState('compose'));
  const item = useRecoilValue(materialItemSelector(target));
  const close = useClosePopup();
  if (!item || !item.specialExtend) return null;
  const onClick = async () => {
    try {
      Toast.loading('合成中...');
      await composeImage({ toolId: item.toolId });
      await imagesV3Data.refresh({});
      Toast('合成成功');
      close('compose');
    } catch ({ message }) {
      Toast(message);
    }
  };
  return (
    <ImageOperationPopup
      className={styles.container}
      type="compose"
      title="合成座驾"
      onClick={onClick}
    >
      <img src={item.specialExtend.composeImageLogo} alt="" />
      <div className={styles.text}>
        你正在合成{item.specialExtend.composeImageName}
      </div>
      <div className={styles.text}>
        需要消耗
        <span
          className={styles.piece}
          style={{ backgroundImage: `url(${item.logo})` }}
        />
        <span className={styles.cost}>{item.specialExtend.composeNeed}</span>
      </div>
    </ImageOperationPopup>
  );
};

export default ComposePopup;
